import React, { Component } from 'react';
import { Slider, Handles, Tracks, Rail, Ticks} from 'react-compound-slider'
import {observer} from 'mobx-react'
import {presets} from "../../stores";

@observer
export default class CompoundSlider extends Component{
    onChange = values => {
        presets.incInfrastructure(values[0])
    };

    render(){
        const sliderStyle = {  // Give the slider some width
            position: 'relative',
            width: this.props.width,
            height: '100%',
            margin: '0 auto'
        };

        const railStyle = {
            cursor:'pointer',
            position: 'absolute',
            width: this.props.width,
            height: 8,
            borderRadius: 5,
            backgroundColor:'#d9d9d9',
        };
        return(
            <div style={{padding:'0 15px'}}>
            <div style={{margin: '2rem 0  4.3rem'}}>
                <Slider
                    rootStyle={sliderStyle}
                    domain={[3000000, 5000000]}
                    values={[presets.infrastructure]}
                    mode={2}
                    step={100000}
                    onUpdate={this.onChange}
                    onChange={this.onChange}
                >
                     <Rail>
                    {({ getRailProps }) => (  // adding the rail props sets up events on the rail
                        <div style={railStyle} {...getRailProps()} />
                    )}
                     </Rail>
                    <Handles>
                        {({ handles, getHandleProps }) => (
                            <div className="slider-handles">
                                {handles.map(handle => (
                                    <Handle
                                        key={handle.id}
                                        handle={handle}
                                        getHandleProps={getHandleProps}
                                    />
                                ))}
                            </div>
                        )}
                    </Handles>
                    <Tracks right={false}>
                        {({ tracks, getTrackProps }) => (
                            <div className="slider-tracks">
                                {tracks.map(({ id, source, target }) => (
                                    <Track
                                        key={id}
                                        source={source}
                                        target={target}
                                        getTrackProps={getTrackProps}
                                    />
                                ))}
                            </div>
                        )}
                    </Tracks>
                    <Ticks count={2}>
                        {({ ticks }) => (
                            <div>
                                {ticks.map(tick => (
                                    <Tick key={tick.id} tick={tick} count={ticks.length} />
                                ))}
                            </div>
                        )}
                    </Ticks>
                </Slider>
            </div>
            </div>
        )
    }
}

function Handle({handle: { id, value, percent }, getHandleProps}) {
    return (
        <div
            style={{
                left: `${percent}%`,
                position: 'absolute',
                marginLeft: -15,
                padding:'0 15',
                zIndex: 2,
                width: 30,
                top:-12,
                height: 30,
                border: 0,
                textAlign: 'center',
                cursor: 'pointer',
                borderRadius: '50%',
                backgroundColor: 'rgb(126, 211, 33)',
                color: '#333',
            }}
            {...getHandleProps(id)}
        >
            <div style={{ fontFamily: 'Roboto', fontSize: 11, marginTop: -35 }} />
        </div>
    )
}

function Track({ source, target, getTrackProps }) {
    return (
        <div
            style={{
                position: 'absolute',
                height: 24,
                zIndex: 1,
                top:-8,
                backgroundColor: '#f00',
                opacity:0,
                borderRadius: 5,
                cursor: 'pointer',
                left: `${source.percent}%`,
                width: `100%`,
            }}
            {...getTrackProps()}
        />
    )
}

function Tick({ tick, count }) {
    return (
        <div>
            <div
                style={{
                    position: 'absolute',
                    marginTop: 22,
                    marginLeft: -0.5,
                    width: 1,
                    height: 8,
                    backgroundColor: 'silver',
                    left: `${tick.percent}%`,
                }}
            />
            <div
                style={{
                    position: 'absolute',
                    marginTop: 30,
                    fontSize: 10,
                    textAlign: 'center',
                    marginLeft: `${-(100 / count) / 2}%`,
                    width: `${100 / count}%`,
                    left: `${tick.percent}%`,
                }}
            >
                {(tick.value/1000000) + ' млн'}
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/shared/components/CompoundSlider/index.js